module.exports = __webpack_public_path__ + "static/media/education.5e6aebc1.2b8a77eb.svg";